<template>
    <div class="text-left pa-4">{{ $t('loading') }}</div>
</template>

<script>
export default {
    name: 'Loading'
};
</script>
